var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onDownloadExcel}},[_vm._v(_vm._s(_vm.title || '导出数据'))]),_c('form',{ref:"downloadForm",attrs:{"action":_vm.exportUrl,"method":"post","target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":"data"},domProps:{"value":_vm.downloadParams}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }